<template>
  <section class="mt-8 relative space-y-8">
    <account-users
      :key="componentKey"
      :users="users"
      :loading="isLoadingUsers"
      :subscriptions="subscriptionIDS"
      @update-permissions="handleUpdatePermissions"
      @refresh-users="handleRefeshUsers"
    />

    <account-user-invite-list
      :invites="invites"
      @invite-revoked="getInvites"
      :loading="isLoadingInvites"
    />

    <account-user-invite @invited="getInvites"/>
  </section>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';
import AccountUserInvite from '@/app/modules/account/components/account-user-invite/account-user-invite.vue';
import AccountUserInviteList from '@/app/modules/account/components/account-user-invite-list/account-user-invite-list.vue';
import AccountUsers from '@/app/modules/account/components/account-users/account-users.vue';

export default {
  name: 'account-users-container',
  components: {
    AccountUserInvite,
    AccountUserInviteList,
    AccountUsers,
  },
  data() {
    return {
      componentKey: 0,
      users: [],
      invites: [],
      isLoadingInvites: true,
      isLoadingUsers: true,
    };
  },
  computed: {
    accountID() {
      return this.$store.getters['account/getActiveAccount'].uuid;
    },
    subscriptions() {
      return this.$store.getters['billing/getSubscriptions'];
    },
    subscriptionIDS() {
      return this.subscriptions.map(sub => ({
        id: sub.id,
        type: sub.app,
        qty: sub.level === 'BASE' ? sub.quantity : null,
      }));
    },
  },
  methods: {
    forceRender() {
      this.componentKey += 1;
    },
    handleRefeshUsers() {
      this.$store.dispatch('toggleLoading', true, { root: true });
      this.getAccountUsers().then(() => {
        this.forceRender();
        this.$store.dispatch('toggleLoading', false, { root: true });
      });
    },
    getAccountUsers() {
      let accountUsers;
      return API.get(`${ENDPOINTS.GET_ACCOUNTS}/${this.accountID}/accountuser`)
        .then((res) => {
          accountUsers = res.data.data;
          return Promise.all(res.data.data.map(user => API.get(`${ENDPOINTS.GET_APP_PERMISSIONS}?accountID=${this.accountID}&cognitoID=${user.cognitoID}`)));
        })
        .then((accountUsersPermissions) => {
          const accoutUserPermissions = accountUsersPermissions
            .map(u => ({
              cognitoID: u.data.data.permissions[0].cognitoID,
              permissions: u.data.data.permissions.sort((a, b) => {
                if (a.appName > b.appName) {
                  return 1;
                } if (a.appName < b.appName) {
                  return -1;
                }
                return 0;
              }),
            }));

          this.users = accountUsers.map(accountUser => ({
            ...accountUser,
            appPermissions:
              accoutUserPermissions.filter(perm => perm.cognitoID === accountUser.cognitoID)[0]
                .permissions,
          }));

          this.isLoadingUsers = false;
        })
        .catch(err => console.log(err));
    },
    getInvites() {
      return API.get(`${ENDPOINTS.GET_INVITATIONS}/?accountID=${this.accountID}&status=INVITED`)
        .then((res) => {
          this.invites = res.data.data;
          this.isLoadingInvites = false;
        })
        .catch(err => console.log(err));
    },
    handleUpdatePermissions() {
      this.getAccountUsers();
    },
  },
  mounted() {
    this.getInvites();
    this.getAccountUsers();
  },
};
</script>
